<template>
  <div v-if="!!project" class="container">
    <v-card-text
      class="card mb-5"
      id="card-description-text"
      flat
      v-for="evalFeed in getEvaluations()"
      :key="evalFeed.evaluation ? evalFeed.evaluation.id : evalFeed.feedback.id"
    >
      <div v-if="evalFeed.evaluation && evalFeed.evaluation.score">
        <div class="card-header row">
          <label
            class="details-subtitle title-green col-8"
            v-html="userName(evalFeed.evaluation)"
          ></label>
          <label class="col-4 sentAt">
            <span
              >Avaliado em:
              {{ formatDate(evalFeed.evaluation.createdAt) }}</span
            >
          </label>
        </div>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Critério</th>
                <th class="text-right">Peso</th>
                <th class="text-right">Nota</th>
                <th class="text-right">Pontuação</th>
              </tr>
            </thead>
            <tbody v-if="evalFeed.evaluation.grades">
              <tr v-for="grade in evalFeed.evaluation.grades" :key="grade.name">
                <td>{{ grade.criteria.name }}</td>
                <td class="text-right">{{ grade.criteria.value }}</td>
                <td class="text-right">{{ grade.grade }}</td>
                <td class="text-right">
                  {{ grade.grade * grade.criteria.value }}
                </td>
              </tr>

              <tr class="total">
                <td>SOMATÓRIO</td>
                <td class="text-right">{{ sumValues(evalFeed.evaluation) }}</td>
                <td class="text-right">-</td>
                <td class="text-right">{{ sumTotals(evalFeed.evaluation) }}</td>
              </tr>
              <tr class="title-greenblue">
                <td></td>
                <td class="text-right" colspan="2">Pontuação ponderada</td>
                <td class="text-right finalValue">
                  {{ formatDigits(finalValue) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <div
        v-if="
          evalFeed.evaluation && evalFeed.evaluation.score && evalFeed.feedback
        "
      >
        <hr />
      </div>

      <div v-if="evalFeed.feedback" class="row">
        <label class="col-8">
          <div
            v-if="
              evalFeed.feedback.status &&
              evalFeed.feedback.status !== 'sem_parecer'
            "
          >
            <v-icon
              color="primary"
              v-show="evalFeed.feedback.status === 'indica'"
              >done_all</v-icon
            >
            <v-icon
              color="error"
              v-show="evalFeed.feedback.status === 'nao_indica'"
              >close</v-icon
            >
            Sugestão de: <b>{{ trans(evalFeed.feedback.status) }}</b>
          </div>
        </label>

        <label class="col-4 sentAt">
          <span
            >Parecer enviado em:
            {{ formatDate(evalFeed.feedback.createdAt) }}</span
          >
        </label>

        <label v-if="evalFeed.feedback.feedback" class="col-12 pb-0">
          <b>Justificativa:</b>
        </label>
        <p
          v-if="evalFeed.feedback.feedback"
          class="col-12 py-0 mb-0"
          v-html="evalFeed.feedback.feedback"
        ></p>
      </div>
    </v-card-text>

    <v-card-text v-if="getEvaluations().length == 0" class="card mb-5" flat>
      <h4>Ainda não foram feitas avaliações para essa proposta</h4>
    </v-card-text>
  </div>
</template>


<script>
import {
  mapState,
  // mapActions
} from "vuex";
import { getBRDateTime } from "@/utils/DateUtils";
import i18n from "@/i18n";
export default {
  name: "PollViewEvaluation",
  data: () => ({
    values: 0,
    total: 0,
    finalValue: 0,
  }),
  computed: {
    ...mapState(["publicPoll", "project", "publicProjectEvaluations"]),
  },
  methods: {
    urlImage(typeImage, id) {
      return require(`../../../pages/image/${typeImage}/${id}.png`);
    },
    userName(evaluation) {
      try {
        return evaluation.citizens[0].name;
      } catch (e) {}
    },
    sumValues(evaluation) {
      this.values = evaluation.grades.reduce((a, g) => a + g.criteria.value, 0);
      this.recalculate();
      return this.values;
    },
    sumTotals(evaluation) {
      this.total = evaluation.grades.reduce(
        (a, g) => a + g.grade * g.criteria.value,
        0
      );
      this.recalculate();
      return this.total;
    },
    recalculate() {
      if (this.values && this.total) {
        this.finalValue = this.total / this.values;
      }
    },
    showField(fieldName) {
      if (this.project === null || this.project == undefined) {
        return false;
      }
      return this.publicPoll.configuration.projectDataForDisplay[fieldName];
    },
    trans(text) {
      return i18n.t(text);
    },
    formatDate(dateStr) {
      return getBRDateTime(dateStr);
    },
    formatDigits(x) {
      return x.toLocaleString("pt-br", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    },
    getEvaluations() {
      return this.publicProjectEvaluations.filter(
        (item) => (item.evaluation && item.evaluation.score) || item.feedback
      );
    },
  },
};
</script>

<style scoped>
.card-header {
  margin-bottom: 20px;
}

.sentAt {
  display: flex;
  flex-direction: column;
  text-align: right;
  font-weight: 600;
  padding: 0 12px;
  font-size: 12px;
  color: #575757;
}

.finalValue {
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/poll/view/Evaluation.vue